import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDownIcon, MenuIcon, XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Logo } from '../ui/Logo';
import { Button } from '../ui/Button';
type ArabicNavItem = {
  label: string;
  fallback: string;
  to?: string;
  children?: Array<{
    label: string;
    fallback: string;
    to?: string;
  }>;
};
const navigation: ArabicNavItem[] = [{
  label: 'HOME',
  fallback: 'الرئيسية'
}, {
  label: 'ABOUT',
  fallback: 'من نحن',
  to: '/ar/about',
  children: [{
    label: 'Who We Are',
    fallback: 'من نحن',
    to: '/ar/about#who-we-are'
  }, {
    label: 'Vision & Mission',
    fallback: 'الرؤية والرسالة',
    to: '/ar/about#vision-mission'
  }, {
    label: 'Why Non-Muslim Countries',
    fallback: 'لماذا الدول غير المسلمة؟',
    to: '/ar/about#why-non-muslim-countries'
  }, {
    label: 'Governance & Transparency',
    fallback: 'الحوكمة والشفافية',
    to: '/ar/about#governance'
  }, {
    label: 'Leadership & Team',
    fallback: 'القيادة والفريق',
    to: '/ar/about#leadership-team'
  }]
}, {
  label: 'CHILDREN',
  fallback: 'الأطفال',
  to: '/ar/children',
  children: [{
    label: 'For Children',
    fallback: 'للأطفال',
    to: '/ar/children'
  }, {
    label: 'Kids Programs',
    fallback: 'برامج الأطفال',
    to: '/ar/children/kids-programs'
  }, {
    label: 'Online Learning',
    fallback: 'التعلّم عبر الإنترنت',
    to: '/ar/children/online-learning'
  }, {
    label: 'Values & Identity',
    fallback: 'القيم والهوية',
    to: '/ar/children/values-identity'
  }, {
    label: 'Scholarships',
    fallback: 'المنح الدراسية',
    to: '/ar/children/scholarships'
  }]
}, {
  label: 'PARENTS',
  fallback: 'الآباء والأمهات',
  to: '/ar/parents',
  children: [{
    label: 'For Parents',
    fallback: 'للآباء والأمهات',
    to: '/ar/parents'
  }, {
    label: 'Membership',
    fallback: 'العضوية',
    to: '/ar/parents/membership'
  }, {
    label: 'Parenting in Non-Muslim Countries',
    fallback: 'التربية في الدول غير المسلمة',
    to: '/ar/parents/parenting-in-non-muslim-countries'
  }, {
    label: 'Preventing Discrimination',
    fallback: 'الوقاية من التمييز',
    to: '/ar/parents/preventing-discrimination'
  }, {
    label: 'Resources & Guidance',
    fallback: 'الموارد والإرشاد',
    to: '/ar/parents/resources-guidance'
  }]
}, {
  label: 'ADULTS',
  fallback: 'البالغون',
  to: '/ar/adults',
  children: [{
    label: 'For Adults',
    fallback: 'للبالغين',
    to: '/ar/adults'
  }, {
    label: 'Annual Programs',
    fallback: 'البرامج السنوية',
    to: '/ar/adults/annual-programs'
  }, {
    label: 'Core Courses',
    fallback: 'الدورات الأساسية',
    to: '/ar/adults/core-courses'
  }, {
    label: 'Professional Development',
    fallback: 'التطوير المهني',
    to: '/ar/adults/professional-development'
  }, {
    label: 'Creative Learning',
    fallback: 'التعلّم الإبداعي',
    to: '/ar/adults/creative-learning'
  }]
}, {
  label: 'PARTNERSHIP',
  fallback: 'الشراكات',
  to: '/ar/partnership',
  children: [{
    label: 'Get Involved',
    fallback: 'شارك معنا',
    to: '/ar/partnership'
  }, {
    label: 'Donate for Children',
    fallback: 'التبرع للأطفال',
    to: '/ar/partnership/donate-for-children'
  }, {
    label: 'Scholarships Program',
    fallback: 'برنامج المنح الدراسية',
    to: '/ar/partnership/scholarships'
  }, {
    label: 'Institutional Partners',
    fallback: 'الشركاء المؤسسيون',
    to: '/ar/partnership/institutional-partners'
  }, {
    label: 'Become a Partner',
    fallback: 'كن شريكًا',
    to: '/ar/partnership/become-a-partner'
  }]
}, {
  label: 'CONTACT',
  fallback: 'تواصل معنا',
  to: '/ar/contact',
  children: [{
    label: 'Get In Touch',
    fallback: 'تواصل معنا',
    to: '/ar/contact'
  }, {
    label: 'General Inquiry',
    fallback: 'استفسار عام',
    to: '/ar/contact#general-inquiry'
  }, {
    label: 'Become a Teacher',
    fallback: 'كن معلّمًا',
    to: '/ar/contact#become-a-teacher'
  }, {
    label: 'Volunteers',
    fallback: 'المتطوعون',
    to: '/ar/contact#volunteers'
  }, {
    label: 'Careers',
    fallback: 'الوظائف',
    to: '/ar/contact#careers'
  }]
}];
export function ArabicHeader() {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState<string | null>(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openMobileSection, setOpenMobileSection] = useState<string | null>(null);
  const translate = (_source: string, arabicCopy: string) => arabicCopy;
  const joinLabel = 'انضم الآن';
  useEffect(() => {
    setMobileOpen(false);
    setOpenMobileSection(null);
  }, [location.pathname]);
  return <>
      <div className="w-full bg-forest-700 text-ivory" data-id="element-418" data-mp="3acu0rcrwzh2a">
        <div className="mx-auto flex h-9 max-w-container items-center justify-between px-5 text-[12px] md:px-8 lg:px-10" data-id="element-419" data-mp="3add9q3zl6v46">
          <p className="truncate font-medium text-ivory/85" data-id="element-420" data-mp="31cfgmgqos80d">المركز الدولي للتعلّم الإسلامي</p>
          <div className="mr-4 flex shrink-0 items-center gap-2" dir="ltr" data-id="element-421" data-mp="31e8bkyrxt3sj">
            <Link to="/en" className="font-medium text-ivory/75 transition hover:text-sand-200" data-id="element-422" data-mp="2we45m2onnrgk">
              English
            </Link>
            <span className="text-ivory/40" aria-hidden="true" data-id="element-423" data-mp="1gu4kzoo08phs">|</span>
            <span className="font-semibold text-ivory" data-id="element-424" data-mp="1gwhbwrbqqa6z">العربية</span>
          </div>
        </div>
      </div>

      <header className="sticky top-0 z-50 border-b border-ink-900/5 bg-ivory/95 backdrop-blur" dir="rtl" data-id="element-425" data-mp="1ku5d2c410z7b">
        <div className="relative mx-auto flex h-[90px] max-w-container items-center justify-between gap-6 px-5 md:px-8 lg:px-10" data-id="element-426" data-mp="t4sgh23mh5lt">
          <Link to="/ar" className="shrink-0" aria-label="الصفحة الرئيسية" data-id="element-427" data-mp="x5m55xow2ofr">
            <Logo className="!ml-0" data-id="element-428" data-mp="125qm1otpll6i" />
          </Link>

          <nav className="absolute left-1/2 hidden -translate-x-1/2 items-center justify-center gap-5 whitespace-nowrap text-center text-[13px] font-semibold lg:flex xl:gap-6 xl:text-[14px]" data-id="element-429" data-mp="123xabv48oarn">
            {navigation.map(item => {
            const itemLabel = translate(item.label, item.fallback);
            if (!item.children) {
              const isActive = location.pathname === '/ar';
              return <Link key={item.label} to="/ar" className={`relative py-2 transition-colors ${isActive ? 'text-forest-700' : 'text-ink-700 hover:text-forest-700'}`} data-id="element-430" data-mp="1crqftn34xuak">
                    {itemLabel}
                    {isActive && <span className="absolute inset-x-0 -bottom-px h-0.5 rounded-full bg-sand-400" data-id="element-431" data-mp="yro4kjpc1z4a" />}
                  </Link>;
            }
            const isOpen = openMenu === item.label;
            const isActive = item.to ? location.pathname === item.to || location.pathname.startsWith(`${item.to}/`) : false;
            return <div key={item.label} className="relative" onMouseEnter={() => setOpenMenu(item.label)} onMouseLeave={() => setOpenMenu(null)} data-id="element-432" data-mp="2j6zq7p3xlpug">
                  {item.to ? <Link to={item.to} className={`relative inline-flex items-center gap-1 py-2 transition-colors ${isActive ? 'text-forest-700' : 'text-ink-700 hover:text-forest-700'}`} aria-expanded={isOpen} aria-haspopup="menu" onClick={() => setOpenMenu(isOpen ? null : item.label)} data-id="element-433" data-mp="2qrbqhq9rfqzf">
                      {itemLabel}
                      <ChevronDownIcon size={14} strokeWidth={2} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-434" data-mp="3adzq2g8juo3p" />
                      {isActive && <span className="absolute inset-x-0 -bottom-px h-0.5 rounded-full bg-sand-400" data-id="element-435" data-mp="3oek83a6n4fw5" />}
                    </Link> : <button type="button" className="inline-flex items-center gap-1 py-2 text-ink-700 transition-colors hover:text-forest-700" aria-expanded={isOpen} aria-haspopup="menu" onClick={() => setOpenMenu(isOpen ? null : item.label)} data-id="element-436" data-mp="1t3j56bxkbmn7">
                      {itemLabel}
                      <ChevronDownIcon size={14} strokeWidth={2} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-437" data-mp="2c258zykgrrut" />
                    </button>}
                  <AnimatePresence data-id="element-438" data-mp="233tjjzvc303y">
                    {isOpen && <motion.div initial={{
                  opacity: 0,
                  y: 4
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: 4
                }} transition={{
                  duration: 0.18,
                  ease: [0.22, 1, 0.36, 1]
                }} className="absolute right-0 top-full z-10 pt-3" data-id="element-439" data-mp="1y247cgwdkgea">
                        <div role="menu" className="min-w-[238px] rounded-2xl border border-ink-900/5 bg-white p-2 shadow-card" data-id="element-440" data-mp="33944bie86wl6">
                          {item.children.map(child => child.to ? <Link key={child.label} to={child.to} role="menuitem" className="block rounded-xl px-4 py-2.5 text-right text-[13px] font-medium text-ink-700 transition hover:bg-sage-50 hover:text-forest-700" onClick={() => setOpenMenu(null)} data-id="element-441" data-mp="3c3s9l8jswe9z">
                                {translate(child.label, child.fallback)}
                              </Link> : <span key={child.label} role="menuitem" className="block rounded-xl px-4 py-2.5 text-right text-[13px] font-medium text-ink-700" data-id="element-442" data-mp="20nkbpkfbdr4n">
                                {translate(child.label, child.fallback)}
                              </span>)}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </nav>

          <div className="flex items-center gap-3" data-id="element-443" data-mp="1wzcg7rtjtt9e">
            <Link to="/ar/waitlist" className="hidden md:inline-flex" data-id="element-444" data-mp="1x0ni1m3foqxv">
              <Button variant="gold" size="sm" data-id="element-445" data-mp="21yys9xxn53gm">
                {joinLabel}
              </Button>
            </Link>
            <button type="button" className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-ink-900/10 text-ink-900 lg:hidden" aria-label={mobileOpen ? 'إغلاق القائمة' : 'فتح القائمة'} aria-expanded={mobileOpen} onClick={() => setMobileOpen(open => !open)} data-id="element-446" data-mp="26yl5i7dgyjpf">
              {mobileOpen ? <XIcon size={18} data-id="element-447" data-mp="3mfoig5cgzimk" /> : <MenuIcon size={18} data-id="element-448" data-mp="3mh9cltuvgzjw" />}
            </button>
          </div>
        </div>

        <AnimatePresence data-id="element-449" data-mp="3higaexl1cuz1">
          {mobileOpen && <motion.nav initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} transition={{
          duration: 0.22
        }} className="overflow-hidden border-t border-ink-900/5 bg-ivory lg:hidden" aria-label="التنقل الرئيسي" data-id="element-450" data-mp="izrh8lwadl0d">
              <div className="mx-auto flex max-w-container flex-col px-5 py-4 text-right md:px-8" data-id="element-451" data-mp="4abqv70o3hl7">
                {navigation.map(item => {
              const itemLabel = translate(item.label, item.fallback);
              const hasChildren = Boolean(item.children?.length);
              const expanded = openMobileSection === item.label;
              const isActive = item.to ? location.pathname === item.to || location.pathname.startsWith(`${item.to}/`) : false;
              if (!hasChildren) {
                return <Link key={item.label} to="/ar" className={`border-b border-ink-900/5 py-3 text-sm font-semibold transition ${location.pathname === '/ar' ? 'text-forest-700' : 'text-ink-900 hover:text-forest-700'}`} onClick={() => setMobileOpen(false)} data-id="element-452" data-mp="2mf37c4uwbl8n">
                        {itemLabel}
                      </Link>;
              }
              return <div key={item.label} className="border-b border-ink-900/5" data-id="element-453" data-mp="3sxjciwqwyi8q">
                      <button type="button" className={`flex w-full items-center justify-between py-3 text-sm font-semibold transition ${isActive ? 'text-forest-700' : 'text-ink-900 hover:text-forest-700'}`} onClick={() => setOpenMobileSection(expanded ? null : item.label)} aria-expanded={expanded} aria-controls={`mobile-${item.label.toLowerCase()}`} data-id="element-454" data-mp="1px0afq4p7g9">
                        <span data-id="element-455" data-mp="24xe440vz9z6e">{itemLabel}</span>
                        <ChevronDownIcon size={16} strokeWidth={2} className={`shrink-0 transition-transform ${expanded ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-456" data-mp="2004iyxfmg9od" />
                      </button>
                      <AnimatePresence initial={false} data-id="element-457" data-mp="kic6wems07jt">
                        {expanded && <motion.div id={`mobile-${item.label.toLowerCase()}`} initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.2,
                    ease: [0.22, 1, 0.36, 1]
                  }} className="overflow-hidden" data-id="element-458" data-mp="fkstfgxwjysx">
                            <div className="flex flex-col gap-1 border-r border-sand-300/60 pb-3 pr-4" data-id="element-459" data-mp="2k1z3kt5nwr4n">
                              {item.children!.map(child => child.to ? <Link key={child.label} to={child.to} className="py-2 text-[13px] font-medium leading-loose text-ink-700 transition hover:text-forest-700" onClick={() => setMobileOpen(false)} data-id="element-460" data-mp="2t25blzilcywf">
                                    {translate(child.label, child.fallback)}
                                  </Link> : <span key={child.label} className="py-2 text-[13px] font-medium leading-loose text-ink-500" data-id="element-461" data-mp="1sv0alfzdhyhg">
                                    {translate(child.label, child.fallback)}
                                  </span>)}
                            </div>
                          </motion.div>}
                      </AnimatePresence>
                    </div>;
            })}
                <Link to="/ar/waitlist" className="mt-4 w-full" data-id="element-462" data-mp="1555u8ofuhrsg">
                  <Button variant="gold" className="w-full" data-id="element-463" data-mp="114c8a0lyqn27">
                    {joinLabel}
                  </Button>
                </Link>
              </div>
            </motion.nav>}
        </AnimatePresence>
      </header>
    </>;
}